<template>

	<div class="fixed-bottom p-2 text-center bg-danger text-light" id="cookie_bar" v-if="displayCookieBar">
        FULLSIX and all of subpages uses cookies for statistical purposes only and we do not save anything. Do you agree to use cookies for statistical purposes? <button class="btn btn-light" id="cookies_confirm" v-on:click="saveConsent">I Agree</button>
	</div>

</template>

<script>
    export default {
        data: {
        },
        props: {
            displayCookieBar: Boolean
		},
		methods: {
			saveConsent() {
				this.displayCookieBar = false;
				axios.post(
					'/api/cookie'
				)
			}
		}
    }
</script>
